import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'
import {
  ApprovalGroupForSelectFragment,
  ApprovalGroupSelectorDocument,
  ApprovalGroupSelectorQuery,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

import { ApprovalGroupMultiSelectorProps, ApprovalGroupSelectorProps } from './types'

interface ItemProps {
  approvalGroup: ApprovalGroupForSelectFragment
}

const ApprovalGroupItem = ({ approvalGroup }: ItemProps) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center" key={approvalGroup.id}>
      <Text.Normal size="300">{approvalGroup.name}</Text.Normal>
    </Box>
  )
}
const ApprovalGroupSkeleton = () => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Skeleton width="s240" height="s32" />
    </Box>
  )
}

export const ApprovalGroupSelector = (
  props: ApprovalGroupSelectorProps | ApprovalGroupMultiSelectorProps
) => {
  const { excludedIds } = props

  const extractConnection = (data: ApprovalGroupSelectorQuery) => {
    return data.approvals.approvalGroupsConnection
  }
  const renderEntity = (entity: ApprovalGroupForSelectFragment) => (
    <ApprovalGroupItem approvalGroup={entity} />
  )
  const renderSkeleton = () => <ApprovalGroupSkeleton />

  const filterEntities = (entities: ApprovalGroupForSelectFragment[]) => {
    if (excludedIds?.length) {
      return entities.filter((e) => !excludedIds.includes(e.id))
    }

    return entities
  }

  const selectorConfig = {
    variables: {
      category: props.category,
    },
    document: ApprovalGroupSelectorDocument,
    extractConnection,
    renderEntity,
    renderSkeleton,
    filterEntities,
  }

  if (props.multiple) {
    const selectorProps = { ...props, ...selectorConfig }
    return (
      <EntitySelector.Multiple
        {...selectorProps}
        renderValue={(entities) => (
          <Text.Normal ellipsis>
            {entities.length > 0
              ? entities.map((entity) => entity.name).join(', ')
              : i18n.t('common.select_multiple')}
          </Text.Normal>
        )}
      />
    )
  }

  const selectorProps = { ...props, ...selectorConfig }
  return (
    <EntitySelector
      {...selectorProps}
      renderValue={(entity) => (
        <Text.Normal ellipsis>
          {entity !== null ? entity.name : i18n.t('common.select')}
        </Text.Normal>
      )}
    />
  )
}
